import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import ButtonDate from './DatePickerButtonDate';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const DatePickerActionDates = ({
  onAllActions,
  closeDatePicker,
  debtorAveragePaymentDays,
  handleChange,
  disableWeekend,
  holidayDates,
  buttons,
  showButtonSubtitle,
  showAllActionsButton,
  onRecommendedPaymentTerm,
}) => (
  <DialogActions sx={{ p: 1.5, maxWidth: 350 }}>
    <Grid container spacing={1} sx={{ width: '100%', mt: -1 }}>
      {buttons.map(({ days, label, id }) => (
        <Grid item xs={6} md={4} key={days}>
          <ButtonDate
            func={handleChange}
            disableWeekend={disableWeekend}
            holidayDates={holidayDates}
            showButtonSubtitle={showButtonSubtitle}
            days={days}
            label={label}
            id={id}
          />
        </Grid>
      ))}
      {showAllActionsButton && (
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            onClick={onAllActions}
            id="selectAllDates"
            size="small"
            sx={{ fontSize: '13px', width: '100%', maxHeight: '36px' }}
          >
            Igual para todas
          </Button>
        </Grid>
      )}
      {debtorAveragePaymentDays && (
      <Grid item xs={6}>
        <ButtonDate
          func={onRecommendedPaymentTerm
            ? (newValue, row, e) => {
              onRecommendedPaymentTerm(newValue, row);
              closeDatePicker();
              e.stopPropagation();
            }
            : handleChange}
          disableWeekend={disableWeekend}
          holidayDates={holidayDates}
          days={debtorAveragePaymentDays}
          variant="onboardingOutlined"
          id="button-debtor-recommended-payment-term"
          label={`${debtorAveragePaymentDays}`}
          icon={<InfoIcon className={DEFAULT_ICON_CLASS_NAME} />}
          detail="Plazo sugerido"
          tooltipInfo={onRecommendedPaymentTerm
            ? 'Promedio de pago registrado del receptor. Al seleccionar esta opción se calculará para cada factura según su fecha de emisión.'
            : 'Promedio de pago registrado del receptor.'}
          size="rounded"
        />
      </Grid>
      )}
      <Grid item xs={6} sx={{ ml: 'auto' }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          id="button-save-date"
          sx={{ fontSize: '13px', width: '100%', height: '100%' }}
          onClick={(e) => {
            e.stopPropagation();
            closeDatePicker();
          }}
        >
          <Typography variant="small_2" fontWeight={600}>Aceptar</Typography>
        </Button>
      </Grid>
    </Grid>
  </DialogActions>
);

DatePickerActionDates.propTypes = {
  debtorAveragePaymentDays: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  closeDatePicker: PropTypes.func,
  onAllActions: PropTypes.func,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      days: PropTypes.number.isRequired,
      label: PropTypes.string,
    }).isRequired,
  ),
  disableWeekend: PropTypes.bool,
  holidayDates: PropTypes.instanceOf(Set),
  showAllActionsButton: PropTypes.bool,
  onRecommendedPaymentTerm: PropTypes.func,
  showButtonSubtitle: PropTypes.bool,
};

DatePickerActionDates.defaultProps = {
  debtorAveragePaymentDays: null,
  onAllActions: null,
  disableWeekend: false,
  holidayDates: new Set(),
  closeDatePicker: () => {},
  showAllActionsButton: true,
  buttons: [],
  onRecommendedPaymentTerm: null,
  showButtonSubtitle: true,
};

export default DatePickerActionDates;
